/**
 * Team color palette + helpers — aligned with mobile (packages/mobile/utils/teamColors.ts +
 * packages/mobile/components/match/TeamColorPicker.tsx).
 */

export const TEAM_COLORS = [
  { name: 'Verde', hex: '#4CAF50' },
  { name: 'Azul', hex: '#2196F3' },
  { name: 'Rojo', hex: '#F44336' },
  { name: 'Amarillo', hex: '#FFC107' },
  { name: 'Naranja', hex: '#FF9800' },
  { name: 'Celeste', hex: '#03A9F4' },
  { name: 'Blanco', hex: '#FFFFFF' },
  { name: 'Negro', hex: '#212121' },
  { name: 'Morado', hex: '#9C27B0' },
  { name: 'Rosa', hex: '#E91E63' },
] as const;

export function normalizeTeamColorHex(hex: string): string {
  return hex.trim().toLowerCase();
}

export function areTeamColorsEqual(a: string, b: string): boolean {
  return normalizeTeamColorHex(a) === normalizeTeamColorHex(b);
}

export function getTeamColorName(hex: string): string {
  return TEAM_COLORS.find((c) => areTeamColorsEqual(c.hex, hex))?.name || 'Personalizado';
}

export const DEFAULT_TEAM1_COLOR = '#4CAF50';
export const DEFAULT_TEAM2_COLOR = '#2196F3';
